export const RESULTS_PER_PAGE = 20;
export const RESULTS_PER_POP_UP = 10;
export const RESULTS_PER_PAGE_PLANNING = 50;
export const RESULTS_PER_PAGE_200 = 200;
export const RESULTS_PER_PAGE_500 = 500;

export const NO_PAGINATION = 999999;

export const TEXTS = {
  count: 'Résultats de {from} à {to} sur {count} | Nombre de résultats : {count}',
  filter: 'Filtrer : ',
  filterPlaceholder: 'Rechercher',
  page: 'Page : ',
  noResults: 'Aucun résultat',
  filterBy: '',
  loading: 'Loading...',
  defaultOption: '',
  columns: 'Filtrer par colonne',
  limit: 'table.limit',
};
export const PER_PAGE_VALUE = [20, 50, 100, 200, 500, 1000];
export const NO_PER_PAGE_VALUE = [];

export const SORT_ICON = {
  base: 'mdi',
  up: 'mdi-chevron-up',
  down: 'mdi-chevron-down',
  is: 'mdi-sort',
};

export const EXPORT_EXCEL_LISTE_AFFICHAGE = 'listeaffichage';
